import {
	CurrencyTypeProvider,
	DynamicConfigProvider,
	FCC,
	PortalStackProvider,
	ReactComponentsThemeProvider,
	ToastList,
	ToastProvider,
	createTenantComponentsColors,
	createTenantComponentsTheme,
	getDefaultRemoteConfigFetcher,
	getTheme,
} from "@dgs/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { JarvisAuthProvider } from "./auth";
import { config } from "./config";
import { JarvisLocaleProvider } from "./JarvisLocaleProvider";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: { staleTime: 100000, retry: false },
	},
});
const baseTheme = getTheme(config.mode);
const theme = createTenantComponentsTheme(baseTheme, createTenantComponentsColors(baseTheme.colors));

export const AppProviders: FCC = ({ children }) => {
	return (
		<QueryClientProvider client={queryClient}>
			<DynamicConfigProvider remoteConfigQueryFn={getDefaultRemoteConfigFetcher()}>
				<JarvisAuthProvider>
					<JarvisLocaleProvider>
						<CurrencyTypeProvider>
							<ReactComponentsThemeProvider theme={theme}>
								<ToastProvider>
									<PortalStackProvider>
										<ToastList />
										{children}
									</PortalStackProvider>
								</ToastProvider>
							</ReactComponentsThemeProvider>
						</CurrencyTypeProvider>
					</JarvisLocaleProvider>
				</JarvisAuthProvider>
			</DynamicConfigProvider>
		</QueryClientProvider>
	);
};
